<template>
    <div class="pizzeria-lang">
        <a href="?lang=ru" class="button-lang button-lang-ru" :class="{'selected': lang === 'ru'}"></a>
        <a href="?lang=en" class="button-lang button-lang-en" :class="{'selected': lang === 'en'}"></a>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ButtonLang",
        methods: {
        },
        computed:{
            ...mapGetters('app', {
                lang: 'getLang',
            }),
        }
    }
</script>

<style scoped>

</style>
